/**
 * サブヘッダー
 */
import { SupportComponent } from '@lib/components/support-class';
import { Router } from '@angular/router';
import { AswServiceStoreService, CommonLibService } from '@lib/services';
import { Component } from '@angular/core';
import { MyBooking } from '@common/interfaces/mybooking/mybooking.interface';
import { MyBookingStoreService } from '@common/services/my-booking/my-booking-store.service';
import { MyBookingTabShow } from '@common/helpers/enums/servicing.enum';
import { FEATURE_TO_ROUTE_MAPPING } from '@common/helpers/constants/servicing.contant';
import { ServiceRequestPaymentInputService } from '@common/services/service-request-payment-input/service-request-payment-input-service';
import { SERVICING_ROUTES } from '@conf/routes.config';
import { ServicingCommonStoreService } from '@common/services';
import { ServicingCommonModel } from '@common/interfaces';

/**
 * サブヘッダー
 */
@Component({
  selector: 'asw-service-request-payment-input-sub-header',
  templateUrl: './service-request-payment-input-sub-header.component.html',
})
export class ServiceRequestPaymentInputSubHeaderComponent extends SupportComponent {
  /** 画面タイトル */

  constructor(
    private _common: CommonLibService,
    private _router: Router,
    private _aswServiceService: AswServiceStoreService,
    private _myBookingStoreService: MyBookingStoreService,
    private _serviceRequestPaymentInputService: ServiceRequestPaymentInputService,
    private _servicingCommonStoreService: ServicingCommonStoreService
  ) {
    super(_common);
  }
  public previousPage: string = '';
  public backUrl: string = '';

  init(): void {}

  // (2) 戻るボタン押下処理
  onBack(): void {
    // (2.1) 初期表示時に取得したPNR情報取得API応答を破棄する。
    this._serviceRequestPaymentInputService.pnr$.next({});
    // (2.2) 遷移元機能ID + "-" + 遷移元画面ID = "S01-P033"(予約詳細(サービス)) の場合、
    if (this._serviceRequestPaymentInputService?.transitionSourceFullFunctionPageId === 'S01-P033') {
      // (2.2.1) 以下の内容をパラメータとしてサービシング共通storeで保持する。
      const params: ServicingCommonModel = {
        isFirstDisplay: false,
        completedFunction: '',
        tabShow: MyBookingTabShow.MyBookingTabShowEnum.Service,
      };
      this._servicingCommonStoreService.updateServicingCommon(params);
      // (2.2.2) 予約詳細(S01-P030)へ遷移する。
      this._router.navigate([SERVICING_ROUTES.myBooking]);
    } else {
      // (2.3) 上記以外の場合、遷移元機能ID、遷移元画面IDを基に、直近の遷移元画面へ遷移する。
      this._router.navigateByUrl(
        FEATURE_TO_ROUTE_MAPPING[this._serviceRequestPaymentInputService?.transitionSourceFullFunctionPageId]
      );
    }
  }

  destroy(): void {}
  reload(): void {}

  isDisplayGoBack(): boolean {
    return this._serviceRequestPaymentInputService !== undefined
      ? this._serviceRequestPaymentInputService.isSubHeaderDisplayGoBack
      : true;
  }
}
